export function isNonNegativeInteger(num) {
  /*
   * Checking if number (even stored as string) is non negative integer.
   */
  return !!+('0.1' + num);
}
